/* ==========================================================================
   Guide Section Component
   Collapsible section for user guide content
   ========================================================================== */

import { type ReactNode, useState } from 'react'
import { ChevronDown } from 'lucide-react'

interface GuideSectionProps {
  /** Section title */
  title: string
  /** Unique ID for anchor scrolling */
  id: string
  /** Whether the section starts expanded */
  defaultOpen?: boolean
  /** Section content */
  children: ReactNode
}

export function GuideSection({
  title,
  id,
  defaultOpen = false,
  children,
}: GuideSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div
      id={id}
      className="bg-white rounded-lg shadow-[0_1px_3px_rgba(0,0,0,0.08)] scroll-mt-6"
    >
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-4 sm:p-6 text-left"
      >
        <h2 className="font-serif text-xl text-charcoal">{title}</h2>
        <ChevronDown
          className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>
      {isOpen && (
        <div className="px-4 sm:px-6 pb-4 sm:pb-6 pt-0">
          <div className="border-t border-gray-200 pt-4 space-y-4 text-charcoal leading-relaxed text-sm sm:text-base">
            {children}
          </div>
        </div>
      )}
    </div>
  )
}
